import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Header } from "../../components/Header";
import api  from "../../services/api";
import './home.css'

export const Home = ()=> {

  const [filmes, setFilmes] = useState([]);

  useEffect(()=>{

    async function loadFilmes(){
      const response = await api.get('r-api/?api=filmes')
      console.log(response.data)
      setFilmes(response.data)
    };

    loadFilmes();

  },[]);

  return (
    <div>
        <Header></Header>
        <div className="container">
              {filmes.map((filmes)=>{
                return(
                  <Link to={`/filme/${filmes.id}`} key={filmes.id} className="lista-filmes ">
                      <h1 className="titulo">{filmes.nome}</h1>
                    <img src={filmes.foto} alt={filmes.nome}/>
                  </Link>
                )
              })}
        </div>
    </div>
  );
}


